(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Landing-Grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  const totalPages = document.querySelector('.mw-image-gallery').getAttribute('data-total-pages');
  const thumbnails = document.querySelectorAll('.mw-image-gallery__thumbnail');
  const mainImage = document.getElementById('mw-main-image');
  const mainImageContainer = document.querySelector('.mw-image-gallery__main-image');
  const grids = document.querySelectorAll('.mw-image-gallery__grid');
  const paginationButtons = document.querySelectorAll('.mw-pagination__prev, .mw-pagination__next');
  const pageIndicator = document.getElementById('page-indicator');
  let currentPage = 1;

  function updateMainImage(imageUrl, imageLink, imageAlt) {
    mainImage.src = imageUrl;
    mainImage.alt = imageAlt;

    if (imageLink) {
      let linkElement = mainImageContainer.querySelector('a');
      if (!linkElement) {
        linkElement = document.createElement('a');
        linkElement.classList.add('mw-image-gallery__link');
        linkElement.target = '_blank';
        mainImageContainer.appendChild(linkElement);
        linkElement.appendChild(mainImage);
      }
      linkElement.href = imageLink;
      linkElement.style.display = 'inline-block';
    } else {
      const linkElement = mainImageContainer.querySelector('a');
      if (linkElement) {
        linkElement.remove();
        mainImageContainer.appendChild(mainImage);
      }
    }
  }

  function setActiveThumbnail(thumbnail) {
    document.querySelectorAll('.mw-image-gallery__thumbnail').forEach(t => t.classList.remove('active'));
    thumbnail.classList.add('active');
  }

  function updatePageIndicator() {
    pageIndicator.textContent = `${currentPage}/${totalPages}`;
  }

  function showPage(page) {
    grids.forEach(grid => {
      grid.style.display = grid.dataset.page === page.toString() ? 'grid' : 'none';
    });

    paginationButtons.forEach(button => button.classList.remove('active'));
    const currentPageButton = document.querySelector(`.mw-pagination__page[data-page="${page}"]`);
    if (currentPageButton) {
      currentPageButton.classList.add('active');
    }

    // const firstThumbnail = document.querySelector(`.mw-image-gallery__grid[data-page="${page}"] .mw-image-gallery__thumbnail`);
    // if (firstThumbnail) {
    //   firstThumbnail.click();
    // }

    updatePageIndicator();
  }

  // Event listeners para los thumbnails
thumbnails.forEach((thumbnail, index) => {
  thumbnail.addEventListener('click', () => {
    const imageUrl = thumbnail.dataset.imageUrl;
    const imageLink = thumbnail.dataset.imageLink;
    const imageAlt = thumbnail.dataset.imageAlt;

    updateMainImage(imageUrl, imageLink, imageAlt);
    setActiveThumbnail(thumbnail);

    const lookElement = document.getElementById('look');
    const lookNumber = index + 1;
    if (lookElement) {
      const lookLabelTemplate = window.customStrings?.look_label || '';
      lookElement.textContent = lookLabelTemplate.replace('{{ number }}', lookNumber);
    }
  });
});


  // Evento para las flechas de paginación
  paginationButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (button.classList.contains('mw-pagination__prev') && currentPage > 1) {
        currentPage--;
      } else if (button.classList.contains('mw-pagination__next') && currentPage < totalPages) {
        currentPage++;
      }

      showPage(currentPage);
    });
  });

  // Inicializar el primer thumbnail y la página
  showPage(currentPage);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 980px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
